import React from "react";
import { Outlet } from "react-router-dom";
import { Box, Divider, Typography } from "@mui/material";
import { SettingsNav } from "../../features/admin/settings/components/SettingsNav";
import { useSessionQuery } from "../../features/auth/hooks";

export const SettingsLayout: React.FC = () => {
  const { data: session } = useSessionQuery();
  const isCentralAdmin = session?.user?.is_central_admin ?? false;

  return (
    <Box sx={{ display: "flex", height: "100%", overflow: "hidden" }}>
      {/* Sidebar */}
      <Box
        sx={{
          width: 232,
          flexShrink: 0,
          borderRight: "1px solid",
          borderColor: "divider",
          display: "flex",
          flexDirection: "column",
          overflowY: "auto",
          overflowX: "hidden",
        }}
      >
        <Box sx={{ px: 2.5, pt: 2.5, pb: 1.5 }}>
          <Typography variant="subtitle1" fontWeight={700}>
            Settings
          </Typography>
          <Typography variant="body2" color="text.secondary" sx={{ mt: 0.25 }}>
            Manage clients, participants, and platform settings.
          </Typography>
        </Box>
        <Divider />
        <SettingsNav isCentralAdmin={isCentralAdmin} />
      </Box>

      {/* Content */}
      <Box sx={{ flex: 1, overflow: "auto" }}>
        <Outlet />
      </Box>
    </Box>
  );
};
